module.exports = __webpack_public_path__ + "img/l2.ffe6a92f.jpg";